import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import $ from 'jquery';
import ChapterHeader from 'memo/components/ChapterHeader';
import ParagraphList from 'memo/components/ParagraphList';
import ChapterBottomBar from 'memo/components/ChapterBottomBar';

class ChapterItem extends React.Component {
  static propTypes = {
    chapter: PropTypes.object.isRequired,
    createImageParagraph: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.createImageParagraph = this.createImageParagraph.bind(this);
  }

  componentDidMount() {
    const { chapter } = this.props;

    // Handling image selection when creating paragraph
    $(this.refs.image).on('change', evt => {
      const file = evt.target.files[0];
      if (file) {
        this.props.createImageParagraph(chapter.id, file);
      }
    });
  }

  createImageParagraph() {
    // Triggering input type file seletion event
    $(this.refs.image).click();
  }

  render() {
    const { chapter, ...rest } = this.props;

    return (
      <div className="ui raised segments memos">
        <input type="file" ref="image" style={{ display: 'none' }} />
        <ChapterHeader chapter={chapter} {...rest} />
        <ParagraphList paragraphs={chapter.paragraphs} {...rest} />
        <ChapterBottomBar
          chapter={chapter}
          createImageParagraph={this.createImageParagraph}
        />
      </div>
    );
  }
}

export default pure(ChapterItem);



// WEBPACK FOOTER //
// ./src/modules/memo/components/ChapterItem.js